import { render, staticRenderFns } from "./RptPoliceReport.vue?vue&type=template&id=2f6d61b2&scoped=true&"
import script from "./RptPoliceReport.vue?vue&type=script&lang=js&"
export * from "./RptPoliceReport.vue?vue&type=script&lang=js&"
import style0 from "./RptPoliceReport.vue?vue&type=style&index=0&id=2f6d61b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d61b2",
  null
  
)

export default component.exports